if (!customElements.get('featured-product-carousel')) {
  class featuredPoductCarousel extends HTMLElement {
    constructor() {
      super();

      this.iconWrapper = this.querySelector('.featured-product-carousel__inner');
      this.addHandlers = this.querySelectorAll('.js-add-to-cart');

      this.previousWidth = window.innerWidth;
      this.previousHeight = window.innerHeight;

      this.toggleInitSlider();
      this.handleResize();
      window.addEventListener('resize', this.handleResize.bind(this));

      this.addHandlers.forEach((handler) => {
        handler.addEventListener('click', (e) => {
          window.handlers['addProduct'](e.currentTarget.dataset.id);
        });
      });
    }

    handleResize() {
      const currentWidth = window.innerWidth;
      const currentHeight = window.innerHeight;
      const isHorizontalResize = currentWidth !== this.previousWidth;
      const isVerticalResize = currentHeight !== this.previousHeight;

      if (
        isHorizontalResize && !isVerticalResize
        || isHorizontalResize && isVerticalResize
      ) {
        this.toggleInitSlider();
      }

      this.previousWidth = currentWidth;
      this.previousHeight = currentHeight;
    }

    toggleInitSlider() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = new Swiper(this.querySelector(`#${this.id} .swiper`), {
        loop: false,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        navigation: {
          nextEl: `#${this.id} .swiper-button-next`,
          prevEl: `#${this.id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        }
      });
    }
  }

  customElements.define('featured-product-carousel', featuredPoductCarousel);
}
